import React from "react";
import styled from "styled-components";
import { SectionContainer } from "../components/SectionContainer";
import { SectionTitle } from "../components/SectionTitle";
import AboutImage from "../assets/gallery/about.jpg";

export const AboutSection = () => {
  return (
    <>
      <div id="about" style={{ color: "transparent" }}>
        About
      </div>
      <SectionContainer background={"black"} center>
        <AboutContent>
          <StackedTitle>
            <SectionTitle title="About" />
          </StackedTitle>
          <ImageContainer>
            <AboutImg src={AboutImage} alt="Maya Mistress" />
          </ImageContainer>
          <AboutText>
            <DesktopTitle>
              <SectionTitle title="About" style={{ marginTop: "-50px" }} />
            </DesktopTitle>
            <QuoteStyleTextWrapper>
              <QuoteStyleText>Sensual, yet sadistic. </QuoteStyleText>
              <QuoteStyleText>Playful, yet merciless. </QuoteStyleText>
              <QuoteStyleText> Spicy, yet sweet.</QuoteStyleText>
            </QuoteStyleTextWrapper>
            Female Domination can be experienced as a fetish... Or as something
            more. My personal journey with Power Dynamics started during my
            University studies, when I published a Thesis on the subject. Once I
            added autonomous sexuality and FemDom to my personal experiments
            with power dynamics, I was forever transformed - and I never looked
            back.
            <br /> For years I was a full-time Pro Domme in my home country,
            where I fostered a beautiful clan of faithful slaves and became one
            of the most well-tributed Pro Dommes in South America. But my
            ambition didn't stop there. That's when I came to Europe to expand
            my horizons.
            <br />
            Time has refined Me. Alongside My other ventures — a fruitful and
            passionate path — I indulge in private Rites of Dominance,
            hand-picking those few who serve as instruments of My pleasure and
            self-expression. My art has grown rarer. I give to fewer, but I give
            more deeply. A small circle of loyal, well-trained servants now sate
            most of My hunger for fantasy and consensual cruelty. I accept new
            submissives only on occasion — when intent moves Me beyond curiosity
            into calling.
          </AboutText>
        </AboutContent>
      </SectionContainer>
    </>
  );
};

const AboutContent = styled.article`
  line-height: 2;
  margin-bottom: 4rem;
  display: flex;
  gap: 28px;
  max-width: 1200px;
  font-size: 18px;
  line-height: 2;
  align-items: end;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: stretch;
  }

  @media screen and (max-height: 500px) {
    flex-direction: column;
  }
`;

const ImageContainer = styled.div`
  width: 35%;
  flex-shrink: 0;

  @media screen and (max-width: 900px) {
    width: 100%;
  }

  @media screen and (max-height: 468px) {
    width: 60%;
    margin: 0 auto;
  }
`;

const AboutImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const AboutText = styled.div`
  width: 65%;

  @media screen and (max-width: 900px) {
    width: 100%;
  }

  @media screen and (max-height: 468px) {
    width: 100%;
    font-size: 18px;
  }
`;

const StackedTitle = styled.div`
  display: none;

  @media screen and (max-width: 900px) {
    display: block;
  }
`;

const DesktopTitle = styled.div`
  display: block;

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const QuoteStyleTextWrapper = styled.div`
  margin-bottom: 1rem;
  display: flex;
  width: 100%;
  justify-content: center;

  @media screen and (max-width: 900px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const QuoteStyleText = styled.span`
  font-style: italic;
  text-align: center;
  font-size: 24px;
  margin-right: 5px;
`;
